export default __webpack_public_path__ + "static/media/logo_net_viet.5cb71757.png";